export class KeyValueModel {
  key: string;
  value: string;

  constructor(_key: string, _value: string) {
    this.key = _key;
    this.value = _value;
  }
}
